import React from "react";
import { Prize, Trick, prizeLabel } from "./api";

// Test mode, for admins and for anyone running the site on their own
// machine: choose what the next go lands on, and play again as often as you
// like. The public never sees this, and the server ignores the choices from
// anyone else.

interface Props {
  prizes: Record<Prize, number>;
  prize: Prize | "";
  trick: Trick | "";
  onPrize: (prize: Prize | "") => void;
  onTrick: (trick: Trick | "") => void;
  onReplay?: () => void;
  replaying?: boolean;
}

const PRIZES: Prize[] = ["pct20", "pct13", "guide10", "pct42"];

const TestBar = ({ prizes, prize, trick, onPrize, onTrick, onReplay, replaying }: Props) => (
  <div className="hw-testbar" role="group" aria-label="Test mode">
    <span className="hw-testbar__tag">Test mode · only you see this</span>
    {onReplay ? (
      <button type="button" className="hw-testbar__button" onClick={onReplay} disabled={replaying}>
        {replaying ? "Resetting…" : "Play again"}
      </button>
    ) : (
      <>
        <label>
          Wheel lands on
          <select value={prize} onChange={(event) => onPrize(event.target.value as Prize | "")}>
            <option value="">Random</option>
            {PRIZES.map((option) => (
              <option key={option} value={option}>
                {prizeLabel(option, prizes)}
              </option>
            ))}
          </select>
        </label>
        <label>
          Trick
          <select value={trick} onChange={(event) => onTrick(event.target.value as Trick | "")}>
            <option value="">Random</option>
            <option value="cards">Card trick</option>
            <option value="riddle">Riddles</option>
          </select>
        </label>
      </>
    )}
  </div>
);

export default TestBar;
